import React from 'react';
import cx from 'classnames';
import { SchemaObject } from 'openapi3-ts';
import styles from './SchemaRow.module.scss';
import HideFromUser from 'src/components-v2/Helpers/HideFromUser/HideFromUser';

interface AttributeTypesLabelProps {
  schemaItem: SchemaObject;
  schemaItemSubItems?: SchemaObject;
  required?: boolean;
  type?: string;
  exchangeSpec?: string;
  coreExchangeSpec?: string;
}

const AttributeTypesLabel: React.FC<AttributeTypesLabelProps> = (props) => {
  const {
    schemaItem,
    schemaItemSubItems,
    required,
    type,
    exchangeSpec,
    coreExchangeSpec,
  } = props;

  const typeValue =
    schemaItemSubItems?.type != null
      ? `[${schemaItemSubItems.type}]`
      : schemaItem.type;

  const typeLabels = [
    ...(required &&
    (type === 'request' || exchangeSpec != null || coreExchangeSpec != null)
      ? ['required']
      : []),
    ...(schemaItem.deprecated ? ['deprecated'] : []),
    ...(schemaItem.nullable && (type === 'response' || type === 'link')
      ? ['nullable']
      : []),
    typeValue,
  ].filter(Boolean);

  return (
    <>
      <small className={cx('hide-for-aeo', styles.attributeType)}>
        {typeLabels.map((label) => (
          <span
            key={label}
            className={cx(
              styles.label,
              label === 'required' && styles.labelRequired,
              label === 'deprecated' && styles.labelDeprecated,
            )}
          >
            {label}
          </span>
        ))}
      </small>

      {/* Visually hidden string for markdown parsing */}
      <HideFromUser className='schema-type-for-markdown'>
        {typeLabels.join(', ')}
      </HideFromUser>
    </>
  );
};

export default AttributeTypesLabel;
